module.exports = __webpack_public_path__ + "img/ipu-logo.e5318d21.png";